import UpdateBillingDetailsModal from './UpdateBillingDetailsModal';

export default UpdateBillingDetailsModal;
